import { useCallback, useState } from 'react';
import useCreateHouseholdMutation from 'hooks/mutations/useCreateHouseholdMutation';
import useCreateHouseholdMemberMutation from 'hooks/mutations/useCreateHouseholdMemberMutation';
import { regenerateTokenIfCustomerIdMissing } from 'utils/api';
import { isMinor } from 'pages/AffordaHousehold/utils';

const useCreateHouseholdAndMembers = ({ householdForm }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const createHouseholdMutation = useCreateHouseholdMutation();
  const createHouseholdMemberMutation = useCreateHouseholdMemberMutation({
    householdForm,
  });

  const createHouseholdAndMembers = useCallback(
    async (_householdForm) => {
      try {
        setIsSubmitting(true);
        await createHouseholdMutation.mutateAsync();

        const { members, studentStatus, additionalMinors } =
          _householdForm ?? householdForm;

        const memberPromises = members.map((member) => {
          let payload = member;

          if (isMinor(member)) {
            payload.type = 'minors';
          } else {
            payload.type = 'leaseholders';
          }

          return createHouseholdMemberMutation.mutateAsync({
            member: payload,
            studentStatus,
            additionalMinors,
          });
        });

        await Promise.all(memberPromises);

        await regenerateTokenIfCustomerIdMissing();
      } catch (e) {
        throw e;
      } finally {
        setIsSubmitting(false);
      }
    },
    [createHouseholdMemberMutation, createHouseholdMutation, householdForm],
  );

  return {
    createHouseholdAndMembers,
    isSubmitting,
  };
};

export default useCreateHouseholdAndMembers;
